import ReactGA from 'react-ga4'

const NODE_ENV = process.env.NODE_ENV
const isProduction = NODE_ENV === 'production'

const GATracking = 'G-M07LX4W1SN'

export function GAInit() {
  if (!isProduction) return

  if (GATracking) {
    ReactGA.initialize(GATracking || '')
  }
}

export function GAEvent({ category, action, label }) {
  // if (!isProduction) return

  if (GATracking) {
    ReactGA.event({
      category,
      action,
      label,
      value: 1,
    })
  }
}

export function GASend(page) {
  if (!isProduction) return

  if (GATracking) {
    ReactGA.send(page)
  }
}
